module.exports = __webpack_public_path__ + "fonts/b766accd4a63e31e5d114b2a5c98cdd0.svg";